/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type WebImportRequestMode = typeof WebImportRequestMode[keyof typeof WebImportRequestMode];


export const WebImportRequestMode = {
  titles: 'titles',
  job_details: 'job_details',
} as const;
